/**
 * App Config File
 */
export default {
    appLogo: "https://dashboard.dowa-tht.com/api/static/images/site-logo.png", // App Logo,
    darkLogo: "https://dashboard.dowa-tht.com/api/static/images/site-dark-logo.png", // dark logo
    appLogo2: "https://dashboard.dowa-tht.com/api/static/images/session.png", // App Logo 2 For Login & Signup Page
    brand: "DOWA THT", // Brand Name
    copyrightText: "DOWA THT AMERICA, INC. © 2021 All Rights Reserved.", // Copyright Text
    enableUserTour: (process.env.NODE_ENV || "").trim() === "production" ? true : false, // Enable User Tour
    weatherApiId: "b1b15e88fa797225412429c1c50c122a1", // weather API Id
    weatherApiKey: "69b72ed255ce5efad910bd946685883a", // weather APi key
    env_mode: (process.env.NODE_ENV || "").trim(), // node environment
    baseApiUrl: process.env.NODE_ENV === "development" ? "https://dashboard.dowa-tht.com/api_dev" : "https://dashboard.dowa-tht.com/api", // base api url
    defaultProfileLogo:
        process.env.NODE_ENV === "development"
            ? "https://dashboard.dowa-tht.com/api_dev/static/uploads/default_profile_logo.png"
            : "https://dashboard.dowa-tht.com/api/static/uploads/default_profile_logo.png",
    defaultProfilePhoto:
        process.env.NODE_ENV === "development"
            ? "https://dashboard.dowa-tht.com/api_dev/public/users/default.png"
            : "https://dashboard.dowa-tht.com/api/public/users/default.png",
};
